import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SecurityPanelComponent } from './security-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { SecurityPanelItemModule } from './components/security-panel-item/security-panel-item.module';

@NgModule({
  declarations: [
    SecurityPanelComponent],
  exports: [
    SecurityPanelComponent],
  imports: [
    CommonModule,
    SharedModule,
    SecurityPanelItemModule
  ],
})
export class SecurityPanelModule { }
